export default class Colors {
	readonly water: string = '#69A2E0';
	readonly grass: string = '#A2CB69';
	readonly blockFrame: string = 'gray';
	readonly blockFrameActive: string = 'red';
	readonly bullet: string = 'red';
	readonly text: string = 'white';
	readonly collisionPoint: string = 'red';
	readonly player: string = '#FFC878';
	readonly hand: string = '#FFC878';
	readonly handBorder: string = '#424242';
	readonly vest: string = '#424242';
	readonly waterCircle: string = '#2871C1';
}
